var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.166 12.002 9.596-9.598a.83.83 0 0 0 0-1.166.83.83 0 0 0-1.166 0L12 10.836 2.404 1.238a.83.83 0 0 0-1.166 0 .83.83 0 0 0 0 1.166l9.596 9.598-9.596 9.597a.83.83 0 0 0 0 1.166.8.8 0 0 0 .577.235c.2 0 .424-.082.577-.235l9.596-9.598 9.596 9.598a.82.82 0 0 0 .589.235.87.87 0 0 0 .589-.235.83.83 0 0 0 0-1.166z"
  })));
};
export default SvgClose;